export class Language {
  constructor(public id: string, public displayName: string) {}
}
